<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <vue-page-stack>
      <router-view
        :key="$route.fullPath"
        @pageLoadComplet="pageLoadComplet"
        @pageHomeLoadComplet="pageHomeLoadComplet"
        class="router-view-c"
      ></router-view>
    </vue-page-stack>
    <!-- </transition> -->
    <!-- <div class="ai_service" v-show="pathName!='helpSmart'&&loadComplet" 
      ref="ball"
      :style="{ transform: `translate(${x}px, ${y}px)` }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <span class="iconfont iconaikefu ai_service_icon"></span>
    </div> -->
    <!-- AI客服 -->
    <div
      class="ai_service"
      v-show="pathName != 'helpSmart' && loadComplet"
      ref="ball"
      :style="{ left: `${x}px`, top: `${y}px` }"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <span class="iconfont iconaikefu ai_service_icon"></span>
    </div>

    <!-- 录音 -->
    <div
      class="ai-interview-recording"
      v-show="
        pathName != 'interviewRecordingAgent' &&
        loadComplet&&(stateObject.recordingDeviceOnlineStatus == 1)
      "
      id="aiAudioIcon"
      ref="audioIcon"
      :style="{ left: `${audioX}px`, top: `${audioY}px` }"
      @touchstart="handleTouchAudioStart"
      @touchmove="handleTouchAudioMove"
      @touchend="handleTouchAudioEnd"
    >
      <span class="iconfont icongantanhao-yuankuang"></span>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { mapState } from "vuex";
// import recordingDeviceMixin from "./mixins/recordingDeviceMixin";
Date.prototype.Format = function (fmt) {
  // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  metaInfo: {
    // meta: [{ charset: "utf-8" }, { name: "referrer", content: "no-referrer" }],
  },
  name: "App",
  // mixins: [recordingDeviceMixin], // 使用Mixin
  data() {
    return {
      transitionName: "forward",
      pathName: "",
      loadComplet: false,

      x: -13, //window.innerWidth - 27, // 初始位置（屏幕右侧）
      y: 500,
      startX: 0,
      startY: 0,
      isDragging: false,
      cachePath: "workbench",
      audioX: window.innerWidth - 81, // 初始位置（屏幕右侧）
      audioY: 600,
      startAudioX: 0,
      startAudioY: 0,
      lastAudioTapTime: 0,
      isDraggingAudio: false,
      recordingStatusTimer: null, // 录音设备状态刷新定时器
    };
  },
  computed: {
    ...mapState({
      stateObject: (state) => state.stateObject,
    }),
  },
  created() {
    //this.getProjectInfo();
    //this.getLoginInfo();
    

    document.getElementsByTagName("html")[0].style.fontSize =
      (window.innerWidth / 375) * 16 + "px";
  },
  
  beforeDestroy() {
    // 现有代码
    window.removeEventListener("resize", this.handleResize);
    try {
      // 清除录音设备状态刷新定时器
      if (this.recordingStatusTimer) {
        clearInterval(this.recordingStatusTimer);
      }
    } catch (error) {
      console.error("清除录音设备状态刷新定时器错误:", error);
    }
  },
  watch: {
    $route(to, from) {
      if (to.params["stack-key-dir"] === "forward") {
        this.transitionName = "forward";
      } else {
        this.transitionName = "back";
      }
      this.pathName = to.name;
    },
  },
  mounted() {
    // let that=this;
    // setTimeout(() => {
    //   that.loadComplet=true;
    //   window.addEventListener('resize', this.handleResize);
    // }, 3000);
    // // 添加窗口大小变化监听
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //获取项目信息
    getProjectInfo() {
      SXApi.call(
        function (suc) {
          if (suc.data && suc.data.data) {
            localStorage.setItem("thisProjectInfo", suc.data.data);
          }
        },
        null,
        "FunctionPlugin",
        "get_location",
        {
          key: "thisProjectInfo",
        }
      );
    },
    //获取登录信息
    getLoginInfo() {
      let that = this;
      SXApi.call(
        function (suc) {
          if (suc.data && suc.data.data) {
            var userInfo1 = JSON.parse(suc.data.data);
            let obj = { userInfo: userInfo1 };
            that.$store.commit("stateFn", obj);
          }
        },
        null,
        "FunctionPlugin",
        "get_location",
        {
          key: "userInfo",
        }
      );
    },
    pageLoadComplet(path) {
      this.cachePath = path;
    },
    goHelpSmart() {
      try {
        if (this.pathName == "workbench") {
          if (this.cachePath == "workbench") {
            commonObj.addScrollTop(0, "workbench");
          } else if (this.cachePath == "projectList") {
            commonObj.addScrollTop(1, "projectList");
          } else if (this.cachePath == "resourceList") {
            commonObj.addScrollTop(2, "resourceList");
          } else if (this.cachePath == "customersList") {
            commonObj.addScrollTop(3, "customersList");
          }
        } else {
          commonObj.addScrollTop();
        }
      } catch (error) {}
      this.tourl("helpSmart");
    },
    handleTouchStart(e) {
      this.isClick = true;
      this.isDragging = true;
      this.startX = e.touches[0].clientX - this.x;
      this.startY = e.touches[0].clientY - this.y;
      this.touchStarX = e.touches[0].clientX;
      this.touchStarY = e.touches[0].clientY;
      e.preventDefault(); // 防止页面滚动
    },

    handleTouchMove(e) {
      if (!this.isDragging) return;
      //this.isClick=false;
      const touch = e.touches[0];
      this.x = touch.clientX - this.startX;
      this.y = touch.clientY - this.startY;
      if (
        Math.abs(e.touches[0].clientX - this.touchStarX) > 3 ||
        Math.abs(e.touches[0].clientY - this.touchStarY) > 3
      ) {
        this.isClick = false;
      }
      // 限制在屏幕内
      this.x = Math.max(0, Math.min(this.x, window.innerWidth - 40));
      this.y = Math.max(0, Math.min(this.y, window.innerHeight - 40));

      e.preventDefault(); // 阻止默认行为
    },

    handleTouchEnd() {
      this.isDragging = false;
      if (this.isClick) {
        this.goHelpSmart();
      }
      this.endRemove();
    },

    handleResize() {
      // 窗口大小变化时重新计算位置
      this.x = Math.max(0, Math.min(this.x, window.innerWidth - 40));
      this.y = Math.max(0, Math.min(this.y, window.innerHeight - 40));
    },
    pageHomeLoadComplet() {
      this.loadComplet = true;
      window.addEventListener("resize", this.handleResize);
      //this.getRecordingDeviceInfo(); // 调用Mixin中的方法
      // 设置定时刷新（每5分钟刷新一次）
      this.recordingStatusTimer = setInterval(() => {
        //this.getRecordingDeviceInfo();
      }, 5 * 60 * 1000); // 5分钟 = 5 * 60 * 1000毫秒
    },
    endRemove() {
      try {
        if (
          parseInt(this.$refs.ball.style.left) > window.innerWidth - 42 &&
          parseInt(this.$refs.ball.style.left) < window.innerWidth - 29
        ) {
          this.$refs.ball.style.left = window.innerWidth - 27 + "px";
        }
        if (
          parseInt(this.$refs.ball.style.left) < 2 &&
          parseInt(this.$refs.ball.style.left) > -15
        ) {
          this.$refs.ball.style.left = "-13px";
        }
      } catch (error) {}
    },
    handleTouchAudioStart(e) {
      this.isClick = true;
      this.isDraggingAudio = true;
      this.startAudioX = e.touches[0].clientX - this.audioX;
      this.startAudioY = e.touches[0].clientY - this.audioY;
      this.touchAudioStarX = e.touches[0].clientX;
      this.touchAudioStarY = e.touches[0].clientY;
      e.preventDefault(); // 防止页面滚动
    },

    handleTouchAudioMove(e) {
      if (!this.isDraggingAudio) return;
      //this.isClick=false;
      const touch = e.touches[0];
      this.audioX = touch.clientX - this.startAudioX;
      this.audioY = touch.clientY - this.startAudioY;
      if (
        Math.abs(e.touches[0].clientX - this.touchAudioStarX) > 3 ||
        Math.abs(e.touches[0].clientY - this.touchAudioStarY) > 3
      ) {
        this.isClick = false;
      }
      // 限制在屏幕内
      this.audioX = Math.max(0, Math.min(this.audioX, window.innerWidth - 40));
      this.audioY = Math.max(0, Math.min(this.audioY, window.innerHeight - 40));

      e.preventDefault(); // 阻止默认行为
    },
    handleTouchAudioEnd() {
      this.isDraggingAudio = false;
      if (this.isClick) {
        const now = Date.now();
        if (now - this.lastAudioTapTime <= 300) {
          this.audioAfter();
          this.lastAudioTapTime = 0;
        } else {
          this.lastAudioTapTime = now;
        }
      }
      this.endRemove();
    },
    audioAfter(){
      if(localStorage.getItem("localAudioStute")=="1"){
          this.localAudioSet();
        }else{
          Dialog.confirm({
            title: "是否关闭录音？",
          }).then(() => {
            //this.goAiAudio();
           // this.handleChange();
          });
        }
    },
     checkLocalAudioSet() {
      if(localStorage.getItem("localAudioStute")=="1"){
        //if(this.stateObject.recordingDeviceOnlineStatus != 1){
          document.getElementById("aiAudioIcon").style.display="flex";
        //}
      }else{
        //if(this.stateObject.recordingDeviceOnlineStatus != 1){
          document.getElementById("aiAudioIcon").style.display="none";
        //}
      }
    },
    localAudioSet() {
      let that=this;
      commonObj.localAudioSet(function (suc) {
        that.checkLocalAudioSet();
      });
    },
    // goAiAudio() {
    //   this.tourl("interviewRecordingAgent");
    // },
  },
};
</script>

<style >
@import "./style/common.css";
@import "./iconfont/iconfont.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  @keyframes show {
    0% {
      transform: translateY(100px);
    }

    60% {
      transform: translateY(-80upx);
    }

    100% {
      transform: translateY(0px);
    }
  }
}
.router-view-c {
  position: absolute;
  transition: opacity 0.3s, transform 0.3s;
  width: 100%;
}

.forward-enter,
.back-leave-active {
  opacity: 0.5;
  transform: translateX(100%);
}

.forward-leave-active,
.back-enter {
  opacity: 0.5;
  transform: translateX(-100%);
}
</style>
<style scoped>
.ai_service {
  position: fixed;
  /* bottom: 10vh;
    right: 2px; */
  border-radius: 40px;
  width: 40px;
  height: 40px;
  background-color: #ff8f00;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  /*touch-action: none;  禁用默认触摸行为 */
  /*transition: transform 0.2s;  添加平滑过渡效果 */
}
.ai_service_icon {
  font-size: 30px;
  color: white;
}
.ai-interview-recording{
  position: fixed;
  /* bottom: 10vh;
    right: 2px; */
  border-radius: 40px;
  width: 40px;
  height: 40px;
  background-color: #fff;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-interview-recording .iconfont {
 font-size: 32px;
 color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue